import { v4 } from "uuid";

export const getUniqueFileName = (fileName) => {
  const splitted = fileName.split(".");
  const extension = splitted[splitted.length - 1];
  return `${splitted
    .slice(0, splitted.length - 1)
    .join("")}-${v4()}.${extension}`;
};
